import type { SponsorCampaign } from "./campaignTypes";
import { fetchPartnerCampaign, getStoredPartnerSession } from "./partnerAuth";

/**
 * Campaign loader for the partner portal.
 * Uses a stored session when present; local DEBUG may allow unauthenticated preview.
 */
export async function loadCampaign(
  campaignSlug: string | undefined
): Promise<SponsorCampaign | null> {
  if (!campaignSlug?.trim()) return null;
  const slug = campaignSlug.trim();
  const session = getStoredPartnerSession(slug);
  const result = await fetchPartnerCampaign(slug, session);
  return result.ok ? result.campaign : null;
}

/** Known public slugs for soft 404 copy only. Not a data source. */
export function listKnownCampaignSlugs(): string[] {
  return [
    "dr-squatch",
    "skrewball",
    "draft-kings",
    "amex-esb",
    "bilt-esb",
    "delta-esb",
    "united-esb",
    "capital-one-esb",
    "draft-kings-stadium",
    "food-tour",
    "hexclad-food-tour",
    "gti",
    "gti-food-tour",
    "gti-residency",
    "airbnb",
  ];
}

export function isKnownCampaignSlug(slug: string | undefined): boolean {
  if (!slug?.trim()) return false;
  return listKnownCampaignSlugs().includes(slug.trim());
}
